/* eslint-disable space-before-function-paren */
import { HTTP } from '@/utils/http-common'

export default {
    call(id, streams) {
        return HTTP.post(`/integrations/config/manage/${id}/config/streams/`, streams)
    },
    discover(id, headers) {
        return new Promise((resolve, reject) => {
            return HTTP.get('/integrations/config/manage/' + id + '/discover/', headers).then(res => {
                return resolve(res)
            }).catch((err) => {
                return reject(err)
            })
        })
    },
    execute(id, headers) {
      return new Promise((resolve, reject) => {
        return HTTP.get('/integrations/config/manage/' + id + '/execute/', headers).then(res => {
          return resolve(res)
        }).catch((err) => {
          return reject(err)
        })
      })
    },
    singerioConfig(id, streams) {
        return HTTP.post('/integrations/config/manage/' + id + '/config/', streams)
    },
    discoverFields(id, stream) {
        return HTTP.get('/integrations/config/manage/' + id + '/discover/' + stream + '/fields/')
    },
}
